import React, { useState } from 'react';
import { Image, StyleSheet } from 'react-native';

import { mapPageTestIDs, Theme } from '@constants';

import { OverlayType } from './MapTypes';

import alertsImage from '../../assets/map/legends/alerts.png';
import breathingIndexImage from '../../assets/map/legends/breathing_index.png';
import feelsLikeImage from '../../assets/map/legends/feels_like.png';
import futureRadarImage from '../../assets/map/legends/future_radar.png';
import lightningImage from '../../assets/map/legends/lightning.png';
import regularRadarImage from '../../assets/map/legends/radar.png';
import shortRadarImage from '../../assets/map/legends/radar-short.png';
import satelliteImage from '../../assets/map/legends/satellite.png';
import temperatureImage from '../../assets/map/legends/temperature.png';
import windImage from '../../assets/map/legends/wind.png';

export const MapLegendSizeClass = {
  regular: 'regular',
  short: 'short',
};

// Show a background image that is dependent on the OverlayType specified.
export const MapLegendBackground = ({ overlayType, sizeClass }) => {
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);

  let backgroundImage = alertsImage;

  switch (overlayType) {
    case OverlayType.alerts:
      backgroundImage = alertsImage;
      break;
    case OverlayType.breathingIndex:
      backgroundImage = breathingIndexImage;
      break;
    case OverlayType.feelsLike:
      backgroundImage = feelsLikeImage;
      break;
    case OverlayType.futureRadar:
      backgroundImage = futureRadarImage;
      break;
    case OverlayType.lightning:
      backgroundImage = lightningImage;
      break;
    case OverlayType.radar:
      backgroundImage = sizeClass === MapLegendSizeClass.short ? shortRadarImage : regularRadarImage;
      break;
    case OverlayType.satellite:
      backgroundImage = satelliteImage;
      break;
    case OverlayType.temperature:
      backgroundImage = temperatureImage;
      break;
    case OverlayType.wind:
      backgroundImage = windImage;
      break;
  }

  Image.getSize(backgroundImage, (width, height) => {
    setImageWidth(width / 2);
    setImageHeight(height / 2);
  });

  return (
    <Image
      source={backgroundImage}
      style={[styles.background, { width: Theme.px(imageWidth), height: Theme.px(imageHeight) }]}
      testID={mapPageTestIDs.mapLegendBackground}
    />
  );
};

// MapLegendBackground.propTypes = {
//   overlayType: PropTypes.oneOf(Object.values(OverlayType)).isRequired,
//   sizeClass: PropTypes.oneOf(Object.values(MapLegendSizeClass)),
// };

MapLegendBackground.defaultProps = {
  sizeClass: MapLegendSizeClass.regular,
};

const styles = StyleSheet.create({
  background: {
    fix: 1,
    resizeMode: 'contain',
  },
});
